import React from "react";
import { SVG, IconProps } from "../SVG";
export const SpotAlertOctagon = ({
    spotColor = "#FCB5A9",
    color = "#13126C",
    ...props
}: IconProps) => (
    <SVG xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 40 40" {...props}>
        <g clipPath="url(#AlertOctagon_svg__a)">
            <path
                fill={spotColor}
                d="M4.857 17.78c1.738-5.087 7.916-9.787 13.373-11.594 5.482-1.818 11.979-.362 16.283 3.888 4.304 4.25 6.402 10.611 5.107 15.97-1.26 5.374-5.757 8.608-9.715 10.583-3.983 1.985-7.428 1.992-11.538.997-4.123-.96-8.301-2.541-10.448-6.26-2.147-3.72-4.824-8.487-3.062-13.584Z"
            />
            <path
                fill={color}
                fillRule="evenodd"
                d="M12.321 2.556a1.1 1.1 0 0 1 .778-.323h13.8a1.1 1.1 0 0 1 .778.323l9.767 9.766a1.1 1.1 0 0 1 .322.778v13.8a1.1 1.1 0 0 1-.322.778l-9.767 9.766a1.1 1.1 0 0 1-.778.323H13.1a1.1 1.1 0 0 1-.778-.323l-9.766-9.766a1.1 1.1 0 0 1-.323-.778V13.1a1.1 1.1 0 0 1 .323-.778l9.766-9.766Zm1.234 1.877-9.123 9.123v12.888l9.123 9.123h12.889l9.122-9.123V13.556l-9.123-9.123H13.556ZM19.999 29a1 1 0 1 0 0-2 1 1 0 0 0 0 2Zm0-18c-1.667 0-2.503 1.625-2.5 3.25v.04c.004 1.712.019 9.71 2.5 9.71 2.501 0 2.503-8.125 2.5-9.75-.003-1.625-.832-3.25-2.5-3.25Z"
                clipRule="evenodd"
            />
        </g>
        <defs>
            <clipPath id="AlertOctagon_svg__a">
                <path fill="#fff" d="M0 0h40v40H0z" />
            </clipPath>
        </defs>
    </SVG>
);
SpotAlertOctagon.displayName = "SpotAlertOctagon";
